import "core-js/modules/es.array.map";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { LanguageChoicePropType } from "web/types/language";
import { gettext } from "web/script/modules/django-i18n";
import { getURL } from "web/script/routing/getUrl";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import globals from "web/script/modules/globals";
import environment from "web/script/modules/environment";
import SubCategory from "./../main-navigation-subcategory/main-navigation-subcategory";
import styles from "./main-navigation-gender-menu.css";

function GenderMenu(_ref) {
  var currentCountry = _ref.currentCountry,
      currentCurrency = _ref.currentCurrency,
      currentLanguage = _ref.currentLanguage,
      menu = _ref.menu,
      onCategoryClick = _ref.onCategoryClick,
      onCountrySelectorClick = _ref.onCountrySelectorClick,
      onLanguageSelectorClick = _ref.onLanguageSelectorClick,
      showCountryPicker = _ref.showCountryPicker,
      showLanguageSelector = _ref.showLanguageSelector,
      fullRender = _ref.fullRender;
  var isRebrand = environment.getFeature("rebrand_2020");
  var iconName = isRebrand ? "arrow-icon" : "chevron";
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: classnames(styles.genderMenu)
  }, menu.menus && menu.menus.map(function (submenu) {
    return React.createElement("button", {
      key: submenu.display_name,
      className: classnames(styles.menuItem),
      type: "button",
      onClick: function onClick() {
        onCategoryClick(submenu);
      }
    }, submenu.display_name, !fullRender && React.createElement(SVGIcon, {
      className: styles.menuItemChevron,
      name: iconName
    }));
  }), menu.links && menu.links.map(function (link) {
    var isSaleLink = link.is_sale;
    return React.createElement("button", {
      key: link.text,
      className: classnames(styles.menuItem, _defineProperty({}, styles.saleLink, isSaleLink)),
      type: "button",
      onClick: function onClick() {
        globals.window.location.assign(link.url);
      }
    }, isSaleLink && React.createElement(SVGIcon, {
      className: classnames(styles.saleTag, styles.saleLink),
      name: "tag"
    }), link.text);
  }), React.createElement("button", {
    type: "button",
    className: styles.menuItemBorderless,
    onClick: onCountrySelectorClick
  }, gettext("burger_menu.country_selector", {
    country: currentCountry,
    currency_indicator: currentCurrency
  }), showCountryPicker && !isRebrand && React.createElement(SVGIcon, {
    className: styles.menuItemChevron,
    name: iconName
  })), showLanguageSelector && React.createElement("button", {
    type: "button",
    className: styles.menuItemBorderless,
    onClick: onLanguageSelectorClick
  }, gettext("burger_menu.language_selector", {
    language: currentLanguage.language_name
  }), React.createElement(SVGIcon, {
    className: styles.menuItemChevron,
    name: iconName
  })), React.createElement("a", {
    className: styles.menuItemBorderless,
    href: getURL("helpCentreHomepage")
  }, gettext("header.help.help_center")), React.createElement("a", {
    className: styles.menuItemBorderless,
    href: getURL("helpContactUs")
  }, gettext("header.help.contact_us")), React.createElement("a", {
    className: styles.menuItemBorderless,
    href: getURL("about")
  }, gettext("header.help.about_us")), React.createElement("a", {
    className: styles.menuItemBorderless,
    href: getURL("careers")
  }, gettext("header.help.careers"))), menu.menus && menu.menus.map(function (submenu) {
    return React.createElement(SubCategory, {
      key: submenu.display_name,
      title: submenu.display_name,
      submenu: submenu,
      fullRender: fullRender
    });
  }));
}

GenderMenu.defaultProps = {
  currentCountry: "",
  currentCurrency: "",
  menu: [],
  showCountryPicker: false,
  showLanguageSelector: false,
  fullRender: false
};
GenderMenu.propTypes = {
  menu: PropTypes.object,
  currentCountry: PropTypes.string,
  currentCurrency: PropTypes.string,
  currentLanguage: LanguageChoicePropType,
  onCategoryClick: PropTypes.func.isRequired,
  onCountrySelectorClick: PropTypes.func.isRequired,
  onLanguageSelectorClick: PropTypes.func.isRequired,
  showCountryPicker: PropTypes.bool,
  showLanguageSelector: PropTypes.bool,
  fullRender: PropTypes.bool
};
export default GenderMenu;